import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doInitializeProductForm),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitProductForm),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchProductFormSagas);

import { push as updatePath } from 'react-router-redux';
import { initialize } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { ga } from 'helpers/multitrack';
import * as ObjectUtil from 'helpers/object';
import { setActiveOfferId } from 'helpers/pathToPurchaseHelper';
export var PRODUCT_FORM = 'signup-card-product';
export var productFormAction = createFormAction(PRODUCT_FORM);
export var initializeProductForm = function initializeProductForm(hiddenFields) {
  return {
    type: "INITIALIZE_".concat(PRODUCT_FORM),
    hiddenFields: hiddenFields
  };
};
export function doInitializeProductForm(client, _ref) {
  var hiddenFields;
  return regeneratorRuntime.wrap(function doInitializeProductForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          hiddenFields = _ref.hiddenFields;
          _context.next = 3;
          return put(initialize(PRODUCT_FORM, ObjectUtil.pick(['productId', 'productType', 'resumeSignupLink'], hiddenFields)));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doSubmitProductForm(client, _ref2) {
  var form;
  return regeneratorRuntime.wrap(function doSubmitProductForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          form = _ref2.payload;
          _context2.next = 3;
          return call(setActiveOfferId, form.productId);

        case 3:
          _context2.t0 = form.resumeSignupLink;

          if (!_context2.t0) {
            _context2.next = 8;
            break;
          }

          _context2.next = 7;
          return select(isLoggedIn);

        case 7:
          _context2.t0 = _context2.sent;

        case 8:
          if (!_context2.t0) {
            _context2.next = 13;
            break;
          }

          _context2.next = 11;
          return put(updatePath(form.resumeSignupLink));

        case 11:
          _context2.next = 18;
          break;

        case 13:
          _context2.next = 15;
          return call(ga, 'Membership Purchase', 'Membership Purchase Product Selection');

        case 15:
          _context2.next = 17;
          return put(productFormAction.success(ObjectUtil.pick(['productId', 'productType'], form)));

        case 17:
          return _context2.abrupt("return", _context2.sent);

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function watchProductFormSagas(client) {
  return regeneratorRuntime.wrap(function watchProductFormSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, initializeProductForm().type, doInitializeProductForm, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, productFormAction.REQUEST, doSubmitProductForm, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}